import React from 'react';
import {
  Label,
} from 'semantic-ui-react';


class ReadMore extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      open: false,
      text: this.trimText(this.props.text, this.props.size),
    };
  }

  trimText(text, size){
    if(text.length <= size) return text;
    return text.substr(0,size)+'...';
  }

  handleToggle(){
    const open = !this.state.open;
    this.setState({open: open, text: open ? this.props.text : this.trimText(this.props.text, this.props.size) });
  }

  render(){
    const that = this;
    return (
      <div>
        <p style={that.props.style}>
          {this.state.text.split('\n').map(function(item, key) {
            return (
              <span key={key}>
                {item}
                <br/>
              </span>
            )
          })}
        </p>
        
        {
          this.props.text.length > this.props.size ? (
            <center>
              <Label
                style={{cursor: 'pointer'}}
                onClick={this.handleToggle.bind(this)}>
                  {this.state.open ? 'Weniger lesen' : 'Mehr lesen'}
              </Label>
            </center>
          ) : null
        }
      </div>
    );
  }
}


export default ReadMore;


// WEBPACK FOOTER //
// ./src/components/ReadMore.js